import { UploadFileResult } from "./types";

/**
 * documentUrl is `${cdnHost}/${source}/${organization}/${bussinessUnit}/${uploadPath}`.
 * Strips the host and the source/organization/bussinessUnit prefix, leaving the
 * relative path we originally sent as `path` (plus the generated file name).
 */
export function getDocumentPath(result: UploadFileResult): string {
  const { pathname } = new URL(result.documentUrl);
  const prefix = `/${result.source}/${result.organization}/${result.bussinessUnit}/`;

  return pathname.startsWith(prefix) ? pathname.slice(prefix.length) : pathname.replace(/^\/+/, "");
}

/**
 * Converts a CDN documentUrl back to the relative upload path for PATCH payloads.
 * Relative paths are returned unchanged.
 *
 * e.g. `https://…cloudfront.net/Orion/AGP/AUTO/abc-properties/marketing/…svg`
 *   → `abc-properties/marketing/…svg`
 */
export function toRelativeDocumentPath(value: string): string {
  const trimmed = value.trim();
  if (!trimmed || !/^https?:\/\//i.test(trimmed)) return trimmed;

  try {
    const { pathname } = new URL(trimmed);
    const segments = pathname.replace(/^\/+/, "").split("/");
    // Drop source / organization / businessUnit (first 3 segments)
    return segments.length > 3 ? segments.slice(3).join("/") : segments.join("/");
  } catch {
    return trimmed;
  }
}
